import React from 'react'
import Header from './Header'
import Footer from './Footer'

function About() {
  return (
    <>
    <Header />
    <section className="page-title centred" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets_web/images/resource/bg-img.jpg)`}}>
            <div className="pattern-layer"></div>
            <div className="auto-container">
                <div className="content-box">
                    <h1>About Us</h1>
                    <ul className="bread-crumb clearfix">
                        <li><i className="flaticon-home-1"></i><a href="index.html">Home</a></li>
                        <li>About Us</li>
                    </ul>
                </div>
            </div>
        </section>
     <section className="about-section">
      <div className="auto-container">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 text-column">
            <div className="text-inner">
              <h2 className="three text-center">Welcome to Annapurna Jaggery Products (Organic)</h2>
              
            </div>
           </div>
         </div>
         <div className="row">
          <div className="col-md-7">
            <p className="text-black">
               <strong>Pure • Healthy • Natural</strong> – Just the Way Nature Intended
              </p>
              <p>
                Annapurna Jaggery Products is a scientifically developed and socially driven initiative by Jan Sewa Ashram—a nationally recognized organization dedicated to sustainable rural technologies and public health innovations.
Located in Fatehpur, Uttar Pradesh, we specialize in the production of FSSAI-certified, GST-registered, 100% organic jaggery that is entirely free from harmful chemicals, synthetic colors, and curdling agents.
More than just a sweetener, our jaggery is a functional food (nutraceutical)—bridging traditional Ayurvedic wisdom with modern food science to deliver health-enhancing benefits in every cube, powder, and block.

              </p>
          </div>
          <div className="col-md-5">
             <img src="assets_web/images/about-us.jpg"/>
          </div>
         </div>
      </div>
    </section>
    <Footer />
    </>
  )
}

export default About